import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { useTranslatedActivityType } from "PFApp/activities/show/hooks/use_translated_activity_type";
import { AvailabilityChangelog } from "PFApp/components/changelog/components/availability_changelog/availability_changelog";
import { GenericActivityEvent } from "PFTypes";
import { useTranslation } from "react-i18next";

import { useEventProfiles } from "../../../hooks/use_event_profiles";
import { HistoryEntryProfilesAccordion } from "../components/histor_entry_profiles_accordion";
import { HistoryChangeSection } from "../components/history_change_section";
import { HistoryEntryTemplate } from "../components/history_entry_template";
import { HistoryEntrySubject } from "../components/history_event_subject";
import { HistoryUpdatedAttributes } from "../components/history_updated_attributes";
import { HistoryEntryProps } from "../history_entry";
import { isStructuredAvailabilityChange } from "../sanitize_history_entry.utils";

export const HistoryEntryGeneric = ({ entry }: HistoryEntryProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "show.history" });
  const { targetProfiles, targetProfile, isLoading } = useEventProfiles(entry);
  const activity = useCurrentActivity();
  const activityType = useTranslatedActivityType(activity);

  const badge = t(`entry.type.${entry.event}` as unknown as TemplateStringsArray, { activityType });

  const renderHistoryContent = () => {
    if (targetProfiles && targetProfiles?.length > 1) {
      return (
        <HistoryEntryProfilesAccordion
          profiles={targetProfiles}
          badge={`${badge} (${targetProfiles.length})`}
        />
      );
    } else if (targetProfile) {
      return (
        <HistoryEntrySubject
          badge={badge}
          profile={targetProfile}
          isLoading={isLoading}
          event={entry.event}
        />
      );
    }

    const genericEntry = entry as GenericActivityEvent;
    const availabilityMetadata = genericEntry.metadata?.availability;
    const hasStructuredAvailability = isStructuredAvailabilityChange(availabilityMetadata);

    return (
      <>
        {hasStructuredAvailability && (
          <HistoryChangeSection labelKey="availability" level={1}>
            <AvailabilityChangelog change={availabilityMetadata} />
          </HistoryChangeSection>
        )}
        <HistoryUpdatedAttributes updatedAttributes={genericEntry.diff} metadata={genericEntry.metadata} />
      </>
    );
  };

  return <HistoryEntryTemplate entry={entry}>{renderHistoryContent()}</HistoryEntryTemplate>;
};
